export const userProfile = {
  forgottenPassword: {
    passwordResetEmailSent: 'An email has been sent to you with information on how to reset your password.'
  },
};
